// @flow

import { observer } from "mobx-react";
import React from "react";
import User from "app/models/User";
import UserThumbnail from "app/components/UserThumbnail/UserThumbnail";

import "./TimelineCardSendComment.scss";

type Props = {
    user: ?User,
    onComment: Function,
    disabled?: boolean,
    placeholder: string
};

@observer
export default class TimelineCardSendComment extends React.Component<Props> {
    comment: ?HTMLTextAreaElement;

    sendComment() {
        const comment = this.comment;
        if (!comment || !comment.value) return;

        this.props.onComment(comment.value);
        comment.value = "";
    }

    handleKeyDown(event: Event) {
        if (event.key === "Enter") {
            event.preventDefault();
            this.sendComment();
        }
    }

    render() {
        if(!this.props.user) {
            return null;
        }

        return (
            <div className="TimelineCardSendComment">
                <UserThumbnail image={this.props.user.profile_image} name={this.props.user.username} />
                <input
                    type="text"
                    ref={el => (this.comment = el)}
                    className="form-control"
                    placeholder={this.props.placeholder}
                    onKeyDown={this.handleKeyDown.bind(this)}
                    maxLength="250"
                    disabled={this.props.disabled}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineCardSendComment/TimelineCardSendComment.js